import { Expose } from 'class-transformer'
import { IsDefined } from 'class-validator'
import { Quiz } from '../../entity'

export class GetQuizDTO {

    @Expose()
    @IsDefined()
    quiz!: Quiz

}

